import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "module-common/Modal";
import Button from "module-common/Button";
import Input from "module-common/Input";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { LivechatRegistrationStore, ShowNotice } from "Store";
import TextArea from "module-common/TextArea";
import {
  mutationAddLiveChatDomain,
  mutationVerifyDomain,
  queryCheckDomainVerify
} from "Apollo";
import { graphql, compose } from "react-apollo";
import { Config } from "constant";
import Tooltip from "module-common/Tooltip";
import Icon from "module-common/Icon";

const gqlOptions = {
  options: {
    variables: {
      companyChannelHandlerId: LivechatRegistrationStore.companyChannelHandler
    }
  }
};

export default compose(
  graphql(mutationAddLiveChatDomain, {
    name: "addLiveChatDomain"
  }),
  graphql(queryCheckDomainVerify, gqlOptions),
  graphql(mutationVerifyDomain, {
    name: "verifyDomain"
  })
)(
  observer(
    class LivechatModal extends Component {
      static propTypes = {
        text: PropTypes.string,
        onCancel: PropTypes.func,
        onConfirm: PropTypes.func,
        isConfirmLoading: PropTypes.bool
      };

      componentWillReceiveProps(nextProps) {
        const data = nextProps.data;
        if (data.checkDomainVerify === null) {
          LivechatRegistrationStore.isScriptShow = false;
        }
      }

      render() {
        const { text, onCancel, isConfirmLoading } = this.props;

        return (
          <Modal>
            <Wrapper>
              <Text>{text}</Text>
              <ToolTipWrapper>
                <Label>Enter Your Domain Name</Label>
                <ToolTipEdit text={"Press Enter your domain name"}>
                  <Icon
                    name="information"
                    width={10}
                    height={10}
                    style={{ "margin-top": "5px" }}
                  />
                </ToolTipEdit>
              </ToolTipWrapper>
              <Input
                label="Domain"
                name="domain"
                value={LivechatRegistrationStore.domainName}
                type="text"
                onChange={e =>
                  (LivechatRegistrationStore.domainName = e.target.value)
                }
              />

              <ToolTipWrapper>
                <Label>Enter Dislay Picture URL Livechat</Label>
                <ToolTipEdit text={"Press Enter Display Picture URL Livechat"}>
                  <Icon
                    name="information"
                    width={10}
                    height={10}
                    style={{ "margin-top": "5px" }}
                  />
                </ToolTipEdit>
              </ToolTipWrapper>
              <Input
                label="Livechat"
                name="livechat"
                value={
                  LivechatRegistrationStore.displayPictureCompanyChannelHandler
                }
                type="text"
                onChange={e =>
                  (LivechatRegistrationStore.displayPictureCompanyChannelHandler =
                    e.target.value)
                }
              />

              <ButtonValidateWrapper>
                <ButtonEdit
                  width={300}
                  onClick={this.downloadHtml}
                  color="gray"
                  disabled={LivechatRegistrationStore.isDownloaded}
                >
                  Download HTML
                </ButtonEdit>

                <ButtonEdit
                  width={300}
                  onClick={this.validateHtml}
                  color="gray"
                  disabled={LivechatRegistrationStore.onValidated}
                  style={{ "margin-top": "10px" }}
                >
                  Validate
                </ButtonEdit>
              </ButtonValidateWrapper>
              {/* {LivechatRegistrationStore.isScriptShow ? (
                <ShowScriptWrapper
                  value={LivechatRegistrationStore.script}
                  disabled
                />
              ) : (
                ""
              )} */}

              <Buttons>
                <Button
                  width={80}
                  onClick={onCancel}
                  color="gray"
                  disabled={isConfirmLoading}
                >
                  Cancel
                </Button>
                <Button
                  width={90}
                  onClick={onCancel}
                  disabled={isConfirmLoading}
                >
                  Finish
                </Button>
              </Buttons>
            </Wrapper>
          </Modal>
        );
      }
      downloadHtml = async () => {
        const domainName = LivechatRegistrationStore.domainName;
        const displayPictureUrl =
          LivechatRegistrationStore.displayPictureCompanyChannelHandler;
        if (domainName === "" || displayPictureUrl === "") {
          ShowNotice("download-livechat-html-error");
        } else {
          await this.props
            .addLiveChatDomain({
              variables: {
                domain: domainName,
                displayPicture: displayPictureUrl
              }
            })
            .then(response => {
              const companyChannelHandlerId =
                response.data.addLiveChatDomain.id;
              LivechatRegistrationStore.companyChannelHandler = companyChannelHandlerId;
              LivechatRegistrationStore.isDownloaded = true;
              LivechatRegistrationStore.onValidated = false;
              window.open(
                `${Config.apiUrl}/verify?id=${
                  LivechatRegistrationStore.companyChannelHandler
                }`
              );
            });
        }
      };

      validateHtml = async () => {
        try {
          await this.props
            .verifyDomain({
              variables: {
                companyChannelId:
                  LivechatRegistrationStore.companyChannelHandler
              }
            })
            .then(response => {
              const originalId = response.data.verifyDomain.originalId;
              const scriptCode = `
              <script type="text/javascript">    
                (function(w, d, h, c){
                    var node = d.createElement("script")
                    node.async = "true"
                    node.src = h+c
                    var head = d.getElementsByTagName("head")[0]
                    head.insertBefore(node, null)
                })(window, document, "https://livechat.care.nolimit.id/embed.js?code=", ${originalId})
              </script>
              `;

              LivechatRegistrationStore.script = scriptCode;

              ShowNotice("validate-html-sucess");
            });
        } catch (error) {
          ShowNotice("validate-html-error");
        }
      };
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

const Text = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 1rem;
  text-align: center;
  margin-bottom: 10px;
`;
const Label = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 0.8rem;
  margin-top: 10px;
  margin-left: 2px;
`;

const ButtonValidateWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-around;
`;

const Buttons = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-content: center;
  padding-left: 40px;
  padding-right: 40px;
  /* & > *:first-child {
    margin-right: 20px;
  } */
`;
const ButtonEdit = styled(Button)`
  background: #1f445a;
  &:hover {
    opacity: 1;
    background: #05223e;
  }
`;
// const InputRow = styled()`
//   margin-bottom: 10px;
//   margin-right: 0;
// `;

const ShowScriptWrapper = styled(TextArea)`
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #e2e2e2;
`;
const ToolTipWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 5px;
`;
const ToolTipEdit = styled(Tooltip)`
  z-index: 10;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/channel-panel/LivechatModalWithMutation.js